export const RUNING_MOD = {
  PRODUCTION: "PRODUCTION",
  LOCAL: "LCOAL",
  QA: "QA",
  REVIEW: "REVIEW",
};

export const ENVIREOMENT = RUNING_MOD.PRODUCTION;

const FAMSA = {
    NAME: "Famsa Pay",
    BLANK_LINK: "#!",
    CUSTOMER_ALERT: "ALERT",
    GUESS_USER: "SYS",
    SERVER: 
      ENVIREOMENT === RUNING_MOD.PRODUCTION
        ? {
          SERVER: "https://app.famsafurniture.com/paymentapi",
          SERVER_DOWNLOAND: "https://app.famsafurniture.com/payments/Home/DownloadReceiptIndex",
          SERVER_BANNER: "https://app.famsafurniture.com/paymentapi",
          APPLICATIONID: "sq0idp-No4AJ08O3KyfH7a59mzuOw",
          LOCATIONID: "LB763QG0CRE4D",
          TRANSACTION: "2.25",
        }
        : ENVIREOMENT == RUNING_MOD.QA
        ? {
            SERVER: "http://192.168.21.25:44",
            SERVER_DOWNLOAND: "http://192.168.21.25:44/api/PaymentRecipt",
            SERVER_BANNER: "http://192.168.21.25:7002",
            APPLICATIONID: "sandbox-sq0idb-dTpCqmjFvn2H4VKQLFKh0g",
            LOCATIONID: "LCPKF542826J4",
            TRANSACTION: "2.25",
        }
        : {
            SERVER: "http://localhost/FamsaPayAPI",
            SERVER_DOWNLOAND: "https://app.famsafurniture.com/payments/",
            SERVER_BANNER: "http://localhost/FamsaPayAPI",
            APPLICATIONID: "sandbox-sq0idb-dTpCqmjFvn2H4VKQLFKh0g",
            LOCATIONID: "LCPKF542826J4",
            TRANSACTION: "2.25",
          }
    //Production
    // SERVER: "https://famsafurniture.com/paymentapi",
    // SERVER_DOWNLOAND: "https://famsafurniture.com/payments/",
    // APPLICATIONID: "sq0idp-No4AJ08O3KyfH7a59mzuOw",
    // LOCATIONID: "LB763QG0CRE4D"
    //SandBox
    //SERVER: "http://192.168.21.25:44",
    //SERVER_DOWNLOAND: "http://192.168.21.25:44/api/PaymentRecipt",
    //APPLICATIONID: "sandbox-sq0idb-dTpCqmjFvn2H4VKQLFKh0g",
    //LOCATIONID: "LCPKF542826J4"
    //LocalTest
    // SERVER: "https://localhost:44374",
    // SERVER_DOWNLOAND: "https://famsafurniture.com/payments/",
    // APPLICATIONID: "sandbox-sq0idb-dTpCqmjFvn2H4VKQLFKh0g",
    // LOCATIONID: "LCPKF542826J4"
  };
  
  export default FAMSA;